<template lang="pug">
section#start-from-code
  section.banner-area.relative
    .overlay.overlay-bg
    .container
      .row.fullscreen.align-items-center.justify-content-between
        .col-lg-6.col-md-7.col-sm-8
          .banner-content(v-show="parsing")
            full-loader
          .banner-content(v-show="!parsing")
            h1(v-html="$t('startCode.title')")
            p(v-html="$t('startCode.subtitle')")
            .box
              input.inputfile#file(accept=".json", type="file", name="file", v-on:change="fileAdd")
              label(v-bind:title="uploaderLabel", v-bind:class="{'primary-btn': !file && !loading, 'genric-btn link': file || loading}", for="file")
                | {{ uploaderLabel | crop(15, '...') }}
                loader(v-show="loading")
                span(v-show="!file && !loading").lnr.lnr-cloud-upload
              button.primary-btn.next-btn(v-on:click.prevent="fileTreat", v-show="file")
                | {{ $t('controls.next') }}
                span.lnr.lnr-arrow-right
        .col-lg-5.col-md-5.col-sm-4
          img.cloud.img-fluid(src='static/img/fromcode.png')
      .row
        .col
          router-link.genric-btn.circle.link(to="/start")
            span.lnr.lnr-arrow-left
            | &nbsp;
            | {{ $t('controls.back') }}

</template>

<script>
import Loader from '@/components/partials/Loader';
import FullLoaer from '@/components/partials/FullLoader';

export default {
  name: 'StartFromCode',
  components: {
    loader: Loader,
    'full-loader': FullLoaer,
  },
  data() {
    return {
      session: null,
      sessionId: null,
      sessionPass: null,
      file: null,
      loading: false,
      parsing: false,
    };
  },
  computed: {
    uploaderLabel() {
      if (this.loading) return '';
      return this.file ? `${this.file.name}` : this.$t('controls.upload');
    },
  },
  metaInfo() {
    return {
      title: this.$t('startCode.meta.title'),
    };
  },
  methods: {
    fileAdd() {
      const selectedFile = document.getElementById('file').files[0];
      if (!selectedFile) return;
      this.loading = true;
      this.file = selectedFile;
      const reader = new FileReader();
      reader.onload = (event) => {
        const data = event.target.result;
        const name = this.file.name;
        this.file = {
          name,
          data,
        };
      };
      reader.onloadend = () => {
        this.loading = false;
      };
      reader.readAsText(selectedFile);
    },
    fileTreat() {
      this.parsing = true;
      this.$store.sugarData.loadJSON(this.file.data);
      const l = this.$store.sugarData.getCollection('entries').find();
      if (l.length) {
        this.$store.firstDate = new Date(l[0].Time);
        this.$store.lastDate = new Date(l[l.length - 1].Time);
      }
      this.$router.push('/dashboard');
    },
  },
  mounted() {
  },
};
</script>

<style lang="stylus" scoped>
@import '../../assets/css/variables.styl'

#start-from-code
  overflow hidden
  background white
  .banner-content
    padding-right base-padding

    .loader
      position relative
      top 4px

  .next-btn
    margin-left 15px
  .banner-area
    padding-bottom base-padding

</style>



// WEBPACK FOOTER //
// src/components/pages/Start.FromCode.vue